export const IDENTITY_ACCESS_MANAGE_ROLE = 'identity.access.manage';

export function canManageOrganizationAccess(roles: readonly string[]): boolean {
  return roles.includes(IDENTITY_ACCESS_MANAGE_ROLE);
}
